import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var sv = {
  language: 'sv',
  country: 'se',
  name: 'Svenska',
  embeddedLocale: merge(error, login),
  flags: ['SE'],
};

export { sv as default };
